export enum DBBoolean {
  TRUE = '1',
  FALSE = '0',
}

export type SearchBijlesError = string;

export interface SearchBijlesResponse {
  // filter props are only set when location is found
  filters: {
    distanceBase?: string;
    searchterm?: string;
    lat?: number;
    lng?: number;
  };
  results: SearchBijlesResult[]|SearchBijlesError;
}

export interface SearchBijlesResult {
  Distance: string;
  Permalink: string;
  datum_eind: string;
  datum_start: string;
  forminfopakket: string;
  id_locatie: string;
  id_product: string;
  is_bls: DBBoolean;
  is_elm: DBBoolean;
  is_et: DBBoolean;
  is_hwb: DBBoolean;
  label_logo_url: string;
  label_naam: string;
  last_updated: string;
  loc_coordinator_foto_url: string;
  loc_coordinator_naam: string;
  loc_coordinator_opmerking_extern: string;
  loc_email: string;
  loc_lat: string;
  loc_long: string;
  loc_naam: string;
  loc_name_short_first: string;
  loc_name_short_second: string;
  loc_nr: string;
  loc_postcode: string;
  loc_routelink: string;
  loc_stad: string;
  loc_straat: string;
  loc_telefoon: string;
  loc_type: '0';
  loc_vestiging_foto_url: string;
  meta_description: string;
  opmerking_extern: string;
  opmerking_training: string;
  orderurl: string;
  product_alias: string;
  product_informatie_type: string;
  product_naam: string;
  product_type: string;
  seo_title: string;
  thumbnail_url: string;
  timberpost: {
    ID: string;
    comment_count: string;
    comment_status: string;
    guid: string;
    is_hub: DBBoolean;
    menu_order: string;
    ping_status: string;
    pinged: string;
    post_author: string;
    post_content: string;
    post_content_filtered: string;
    post_date: string;
    post_date_gmt: string;
    post_excerpt: string;
    post_mime_type: string;
    post_modified: string;
    post_modified_gmt: string;
    post_name: string;
    post_parent: string;
    post_password: string;
    post_status: string;
    post_title: string;
    post_type: string;
    to_ping: string;
    vestiging: string;
  };
  vak_naam: string;
  vak_niveau: string;
  zichtbaar: 'yes' | 'no';
}
